import { render } from "./MedalIcon.vue?vue&type=template&id=2c9da6f2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MedalIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c9da6f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c9da6f2', __exports__)) {
    api.reload('2c9da6f2', __exports__)
  }
  
  module.hot.accept("./MedalIcon.vue?vue&type=template&id=2c9da6f2", () => {
    api.rerender('2c9da6f2', render)
  })

}


export default __exports__